@if(!nodeData?.icon){
<img [src]="'assets/images/nodes/external_webhook.svg'" [alt]="workflowName" />
} @else {
<div
  title="{{ nodeData?.label||undefined }}"
  class="digit-container"
  [ngStyle]="{
    'background-color': zuperNodeData?.backgroundColor ,
    'border-color': zuperNodeData?.borderColor
  }"
>
  @if (zuperNodeData?.isZuperIcon) {
  <svg
    class="w-6 h-6"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="500" height="500" />
    <path
      d="M372.125 318.394H195.124L261.346 205.829H112.713L46.3887 318.394H195.124L123.545 440.129H300.462L372.125 318.394Z"
      [attr.fill]="zuperNodeData?.iconColor"
    />
    <path
      d="M127.264 181.242H304.265L238.043 293.807H386.675L453 181.242H304.265L375.843 59.5238H198.927L127.264 181.242Z"
      [attr.fill]="zuperNodeData?.iconColor "
    />
  </svg>
  } @else {
  <img [src]="nodeData?.icon" [alt]="workflowName" class="h-6 w-6" />
  }
</div>
}